// Custom components
import React from "react";

function InputField(props) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    value,
    onChange,
    name,
  } = props;

  return (
    <div className={`${extra}`}>
      {label ? (
        <label
          htmlFor={id}
          className={`text-navy-700 dark:text-white ${
            variant === "auth"
              ? "ml-1.5 text-sm font-medium"
              : "text-xs font-semibold"
          }`}
        >
          {label}
        </label>
      ) : null}
      <input
        disabled={disabled}
        type={type}
        id={id}
        name={name || id}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={onChange || (() => {})}
        className={`${variant === "auth" ? "mt-2 h-12 rounded-xl p-3" : "mt-1 h-10 rounded-lg px-2.5"} flex w-full items-center justify-center border bg-white/0 text-sm outline-none ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
      />
    </div>
  );
}

export default InputField;
